<template>
	<div class="login" v-loading="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<div class="logo">
			<h1 class="hogo"><i>{{setting.web_title}}</i></h1>
		</div>
		<section class="stark-login">
<!--			登录-->
			<form>
				<div id="fade-box">
					<input v-model="item.username" autocomplete="off" placeholder="Username">
					<input v-model="item.password" type="password" placeholder="Password">
					<button type="button" @click="submit">Log In</button>
				</div>
			</form>
			<div class="hexagons">
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<br>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<br>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<br>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<br>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
				<span>&#x2B22;</span>
			</div>
		</section>
		<div id="circle1">
			<div id="inner-cirlce1">
				<h2></h2>
			</div>
		</div>
	</div>
</template>
<script scoped>
export default {
	name: 'Login',
	data(){
        return {
        	// 定义账号密码
			item:{
				username: '',
				password:''
			},
			isLoad:false,
			// 标题
			setting:[]
		}
	},
	created(){
		this.loadData()
	},
	methods:{
		loadData(){
		//	获取标题的地方
		},
		submit(){
			if(this.isLoad)
				return
			this.isLoad = !this.isLoad
			// post 提交方法 将账号密码提交上去
			this.axios.post('/admin/user/login', this.item)
			.then(res => {
				// 返回数据
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '登录成功',
					showClose:false
				});
				// 将返回的数据进行存入缓存
				localStorage.token = res.data.token
				localStorage.login_name = res.data.username
				localStorage.userId = res.data.userId
				// 路由获取
				let redirect = this.$route.query.redirect
				// 进入页面后显示的第一个页面 也要在router中定义
				if(!redirect)
					redirect = '/'
				// 跳转路径
				this.$router.replace({ path: redirect});
			})
			.catch(() => {
				this.isLoad = !this.isLoad
			})
		}
	}
}
</script>
<style scoped>
/*@import "https://fonts.googleapis.com/css?family=Ubuntu:400,700italic";*/
/*@import "https://fonts.googleapis.com/css?family=Cabin:400";*/
.login{
	background: #000;
	background-size: cover;
	height: 100%;
	overflow: hidden;
	position: fixed;
	text-align: center;
	width: 100%;
	top: 0;
}
.logo {
	animation: logo-entry 1s ease-in;
	display: flex;
	justify-content: center;
	margin: 0 auto;
	position: relative;
	z-index: 40;
	margin-top: 100px;
}
.hogo{
	animation: text-glow 1s ease-out infinite alternate;
	font-family: 'Ubuntu', sans-serif;
	position: absolute;
	text-shadow: 0 0 10px #000, 0 0 20px #000, 0 0 30px #000, 0 0 40px #000, 0 0 50px #000, 0 0 60px #000, 0 0 70px #000;
	top: 80px;
	min-width: 500px;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding:0 80px;
}
.hogo i{
	font-size: 48px;
	font-weight: bold;
}
.hogo:before {
	animation: before-glow 1s ease-out infinite alternate;
	border-left: 535px solid transparent;
	border-bottom: 10px solid #00a4a2;
	content: ' ';
	height: 0;
	position: absolute;
	right: 0;
	top: -10px;
	width: 0;
}
.hogo:after {
	animation: after-glow 1s ease-out infinite alternate;
	border-left: 100px solid transparent;
	border-top: 16px solid #00a4a2;
	content: ' ';
	height: 0;
	position: absolute;
	right: -11px;
	top: 24px;
	transform: rotate(-47deg);
	width: 0;
}
#fade-box {
	animation: input-entry 1s ease-in;
	z-index: 4;
}
.stark-login form {
	animation: form-entry 1s ease-in-out;
	background: #111;
	background: linear-gradient(#004746, #111111);
	border: 6px solid #00a4a2;
	box-shadow: 0 0 15px #00fffd;
	border-radius: 5px;
	display: inline-block;
	height: 220px;
	margin: 200px auto 0;
	position: relative;
	z-index: 4;
	width: 500px;
	transition: 1s all;
}
.stark-login form:hover {
	border: 6px solid #00fffd;
	box-shadow: 0 0 25px #00fffd;
	transition: 1s all;
}
.stark-login input {
	background: #222;
	background: linear-gradient(#333333, #222222);
	border: 1px solid #444;
	border-radius: 5px;
	box-shadow: 0 2px 0 #000;
	color: #888;
	display: block;
	font-family: 'Cabin', helvetica, arial, sans-serif;
	font-size: 13px;
	height: 40px;
	margin: 20px auto 10px;
	padding: 0 10px;
	text-shadow: 0 -1px 0 #000;
	width: 400px;
}
.stark-login input:focus {
	animation: box-glow 1s ease-out infinite alternate;
	background: #0B4252;
	background: linear-gradient(#333933, #222922);
	border-color: #00fffc;
	box-shadow: 0 0 5px rgba(0, 255, 253, 0.2), inset 0 0 5px rgba(0, 255, 253, 0.1), 0 2px 0 #000;
	color: #efe;
	outline: none;
}
.stark-login input:invalid {
	border: 2px solid red;
	box-shadow: 0 0 5px rgba(255, 0, 0, 0.2), inset 0 0 5px rgba(255, 0, 0, 0.1), 0 2px 0 #000;
}
.stark-login button {
	animation: input-entry 1s ease-in;
	background: #222;
	background: linear-gradient(#333333, #222222);
	box-sizing: content-box;
	border: 1px solid #444;
	border-left-color: #000;
	border-radius: 5px;
	box-shadow: 0 2px 0 #000;
	color: #fff;
	display: block;
	font-family: 'Cabin', helvetica, arial, sans-serif;
	font-size: 13px;
	font-weight: 400;
	height: 40px;
	line-height: 40px;
	margin: 20px auto;
	padding: 0;
	position: relative;
	text-shadow: 0 -1px 0 #000;
	width: 400px;
	transition: 1s all;
}
.stark-login button:hover,.stark-login button:focus {
	background: #0C6125;
	background: linear-gradient(#393939, #292929);
	color: #00fffc;
	outline: none;
	transition: 1s all;
}
.stark-login button:active {
	background: #292929;
	background: linear-gradient(#393939, #292929);
	box-shadow: 0 1px 0 #000, inset 1px 0 1px #222;
	top: 1px;
}
#circle1 {
	animation: circle1 4s linear infinite, circle-entry 3s ease-in-out;
	background: #000;
	border-radius: 50%;
	border: 10px solid #00a4a2;
	box-shadow: 0 0 0 2px black, 0 0 0 6px #00fffc;
	height: 500px;
	width: 500px;
	position: absolute;
	top: 120px;
	left: 50%;
	margin-left: -250px;
	overflow: hidden;
	opacity: 0.4;
	z-index: 3;
}
#inner-cirlce1 {
	background: #000;
	border-radius: 50%;
	border: 36px solid #00fffc;
	height: 460px;
	width: 460px;
	margin: 10px;
}
#inner-cirlce1:before {
	content: ' ';
	width: 240px;
	height: 480px;
	background: #000;
	position: absolute;
	top: 0;
	left: 0;
}
#inner-cirlce1:after {
	content: ' ';
	width: 480px;
	height: 240px;
	background: #000;
	position: absolute;
	top: 0;
	left: 0;
}
.hexagons {
	animation: logo-entry 1s ease-in;
	color: #000;
	letter-spacing: -0.2em;
	position: absolute;
	text-shadow: 0 0 6px #00fffc;
	top: 410px;
	width: 100%;
	transform: perspective(600px) rotateX(60deg) scale(1.4);
	z-index: 3;
}
.hexagons span{
	line-height: 0.7;
	font-size: 51px;
}
@keyframes logo-entry {
	0% {
		opacity: 0;
	}
	80% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
@keyframes circle-entry {
	0% {
		opacity: 0;
	}
	20% {
		opacity: 0;
	}
	100% {
		opacity: 0.4;
	}
}
@keyframes input-entry {
	0% {
		opacity: 0;
	}
	90% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
@keyframes form-entry {
	0% {
		height: 0;
		width: 0;
		opacity: 0;
		padding: 0;
	}
	20% {
		height: 0;
		border: 1px solid #00a4a2;
		width: 0;
		opacity: 0;
		padding: 0;
	}
	40% {
		width: 0;
		height: 220px;
		border: 6px solid #00a4a2;
		opacity: 1;
		padding: 0;
	}
	100% {
		height: 220px;
		width: 500px;
	}
}
@keyframes box-glow {
	0% {
		border-color: #00b8b6;
		box-shadow: 0 0 5px rgba(0, 255, 253, 0.2), inset 0 0 5px rgba(0, 255, 253, 0.1), 0 2px 0 #000;
	}
	100% {
		border-color: #00fffc;
		box-shadow: 0 0 20px rgba(0, 255, 253, 0.6), inset 0 0 10px rgba(0, 255, 253, 0.4), 0 2px 0 #000;
	}
}
@keyframes text-glow {
	0% {
		color: #00a4a2;
		text-shadow: 0 0 10px #000, 0 0 20px #000, 0 0 30px #000, 0 0 40px #000, 0 0 50px #000, 0 0 60px #000, 0 0 70px #000;
	}
	100% {
		color: #00fffc;
		text-shadow: 0 0 20px rgba(0, 255, 253, 0.6), 0 0 10px rgba(0, 255, 253, 0.4), 0 2px 0 #000;
	}
}
@keyframes before-glow {
	0% {
		border-bottom: 10px solid #00a4a2;
	}
	100% {
		border-bottom: 10px solid #00fffc;
	}
}
@keyframes after-glow {
	0% {
		border-top: 16px solid #00a4a2;
	}
	100% {
		border-top: 16px solid #00fffc;
	}
}
@keyframes circle1 {
	0% {
		-moz-transform: rotate(0deg);
		-ms-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
</style>
